import { Box } from 'components/Box/Box';
import { Tag } from 'components/Tag/Tag';
import { CmsApiCategory } from 'modules/cms/api/types/CmsApiCategory';

type Props = {
  homePageUrl: string | undefined;
  categories: Array<CmsApiCategory>;
};

export function CmsCategories({ homePageUrl, categories }: Props) {
  // Hide parent categories with children present.
  const filteredCategories = categories.filter(
    (category) =>
      category.parentId !== null ||
      categories.every(
        (potentialChild) => potentialChild.parentId !== category.id,
      ),
  );
  return (
    <Box data-qa-id="categories" display="flex" m="-6px" flexWrap="wrap">
      {filteredCategories.map((category) => (
        <Tag
          key={category.slug}
          component={homePageUrl ? 'a' : undefined}
          data-qa-id="category-link"
          // @ts-expect-error fix types
          href={
            homePageUrl ? `/${homePageUrl}?categories=${category.slug}&pq=` : ''
          }
          m="6px"
          $large
        >
          {category.name}
        </Tag>
      ))}
    </Box>
  );
}
